import { Box, Chip } from "@mui/material";
import React from "react";
import { enterpriseTokens } from "styles/theme";

const getStatusColor = (data) => {
    if (!data) return "purple";

    const severity = data;

    // console.log("severity",severity);
    // Case 1: In Progress & overdue
    if (severity === "Critical" ) {
        return { bgColor: "#FEE2E2", textColor: "#B91C1C" };
    }

    // Case 2: In Progress & future due date
    if (severity === "Moderate") {
        return { bgColor: "#FEF3C7", textColor: "#B45309" };
    }

    // Case 3: Completed or Closed
    if (severity === "Low") {
        return { bgColor: "#DCFCE7", textColor: "#15803D" };
    }

    // Default
    return "purple";
};

const StatusBadge = ({ status }) => {
   
    const { bgColor, textColor } = getStatusColor(status);

    return (
        <Chip
            sx={{
                height: "20px",
                borderRadius: "999px",
                backgroundColor: bgColor,
                padding: "2px 6px",
                fontFamily: "Inter, Outfit, sans-serif",
                fontWeight: 700,
                fontSize: "12px",
                border: `1px solid ${enterpriseTokens.lineSoft}`,
            }}
            label={
                <Box sx={{ color: textColor, fontWeight: 600, fontSize: "10px" }}>
                    {status}
                </Box>
            }
        />
    );
};

export default StatusBadge;
